import { z } from 'zod';

export const FORM_SCHEMA = z
  .object({
    is_enabled: z.boolean(),
    sla: z
      .object({
        value: z.string(),
        label: z.string(),
        carrierId: z.string(),
        carrierName: z.string()
      })
      .nullable()
  })
  .refine(data => (data.is_enabled ? data.sla !== null : true), {
    message: 'Carrier Service is required',
    path: ['sla']
  });

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  is_enabled: false,
  sla: null
};
